import {Field2} from "@mytour/ui/form";
import type {UseFormReturn} from "react-hook-form";
import z from "zod";

export const step2Schema = z.object({
  environnementModeVie: z.string().optional(),
  alimentation: z.string().optional(),
  historique: z.string().optional(),
  soinsParticuliers: z.string().optional(),
  commentairesAdditionnels: z.string().optional(),
});

export type Step2Form = z.infer<typeof step2Schema>;

type Props = {
  hookForm: UseFormReturn<Step2Form>;
  disabled: boolean;
};

export function Step2({hookForm, disabled}: Props) {
  return (
    <>
      <p style={{marginBottom: "24px"}}>
        <strong>Notes</strong>
      </p>
      <Field2
        name="environnementModeVie"
        label="Environnement / Mode de vie"
        type="textarea"
        hookForm={hookForm}
        disabled={disabled}
      />
      <Field2
        name="alimentation"
        label="Alimentation (dont supplémentation)"
        type="textarea"
        hookForm={hookForm}
        disabled={disabled}
      />
      <Field2
        name="historique"
        label="Historique (passé méd récent/ancien, soins aux sabots)"
        type="textarea"
        hookForm={hookForm}
        disabled={disabled}
      />
      <Field2
        name="soinsParticuliers"
        label="Soins particuliers (Médications, autres pro...)"
        type="textarea"
        hookForm={hookForm}
        disabled={disabled}
      />
      {/*
            <Field2
                name="commentairesAdditionnels"
                label="Commentaires additionnels dont analyse d'allure"
                type="textarea"
                hookForm={hookForm}
                disabled={disabled}
            /> */}
    </>
  );
}
